// @mui material components
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKInput from 'components/MKInput';
import MKButton from 'components/MKButton';
import MKTypography from 'components/MKTypography';

// Image
import contact_us from 'assets/csdd_images/contact-us.jpg';
import Footer from 'csdd_components/Footer';
import TopNavBar from 'csdd_components/TopNavBar';
import HomeNavBar from 'csdd_components/HomeNavBar';

function ContactUs() {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <Grid container spacing={3} alignItems='center'>
        <Grid item xs={12} lg={6}>
          <MKBox
            display={{ xs: 'none', lg: 'flex' }}
            width='calc(100% - 2rem)'
            height='calc(100vh - 2rem)'
            borderRadius='lg'
            ml={2}
            mt={2}
            sx={{
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundImage: `url(${contact_us})`,
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={4}
          ml={{ xs: 'auto', lg: 6 }}
          mr={{ xs: 'auto', lg: 6 }}
        >
          <MKBox
            bgColor='white'
            borderRadius='xl'
            shadow='lg'
            display='flex'
            flexDirection='column'
            justifyContent='center'
            mt={{ xs: 20, sm: 18, md: 20 }}
            mb={{ xs: 20, sm: 18, md: 20 }}
            mx={3}
          >
            <MKBox
              variant='gradient'
              bgColor='warning'
              coloredShadow='warning'
              borderRadius='lg'
              p={2}
              mx={2}
              mt={-3}
            >
              <MKTypography textGradient variant='h2' color='black'>
                Contact us
              </MKTypography>
            </MKBox>
            <MKBox p={3}>
              <MKTypography variant='body2' color='text' mb={3}>
                For further questions, including partnership opportunities,
                please email&nbsp;
                <span style={{ color: 'black' }}>
                  csddghana@gmail.com&nbsp;
                </span>
                or contact us using our contact form.
              </MKTypography>
              <MKBox
                width='100%'
                component='form'
                method='post'
                autoComplete='off'
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      variant='filled'
                      label='Full Name'
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      type='email'
                      variant='filled'
                      label='Email'
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MKInput
                      variant='filled'
                      label='How may we assist you?'
                      InputLabelProps={{ shrink: true }}
                      multiline
                      fullWidth
                      rows={6}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  justifyContent='center'
                  xs={12}
                  mt={5}
                  mb={2}
                >
                  <MKButton
                    fullWidth
                    type='submit'
                    variant='contained'
                    color='warning'
                  >
                    Send Message
                  </MKButton>
                </Grid>
              </MKBox>
            </MKBox>
          </MKBox>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
}

export default ContactUs;
